import { LOCGPrismicContext, LOCGPrismicContextType } from '../LOCGPrismicContext'
import { useContext } from 'react'

export const useLOCGPrismicContext = (): LOCGPrismicContextType => {
  const context = useContext(LOCGPrismicContext)
  if (!context) {
    throw new Error('useLOCGPrismicContext must be used within a LOCGPrismicContextProvider')
  }

  return context
}
